"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var TextInputMenuItem_1 = require("./TextInputMenuItem");
var TextInputMenu = function (_a) {
    var value = _a.value, open = _a.open, anchorPosition = _a.anchorPosition, className = _a.className, menus = _a.menus, onClick = _a.onClick, onClose = _a.onClose;
    var divRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onClose();
            }
        }
        document.addEventListener('click', handleClickOutside);
        return function () {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return (open && ((0, jsx_runtime_1.jsx)("div", __assign({ ref: divRef, className: (0, classnames_1.default)("\n            squid-absolute \n        squid-z-50 \n        squid-mt-2 \n        squid-border \n        squid-p-component-dropdown-menu-padding \n        squid-border-alias-color-border-base \n        squid-bg-alias-color-bg-base \n        squid-rounded-component-dropdown-menu-border-radius \n        squid-divide-y\n        squid-divide-gray-100", {
            'squid-right-0': anchorPosition === 'right',
            'squid-origin-top-right': anchorPosition === 'right',
            'squid-left-0': anchorPosition === 'left',
            'squid-origin-top-left': anchorPosition === 'left',
            'squid-block': open,
            'squid-overflow-auto squid-max-h-60': open,
        }, className) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-gap-component-dropdown-space squid-flex squid-flex-col" }, { children: menus.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(TextInputMenuItem_1.default, { item: item, onClick: onClick(item), active: value.label === item.label && item.value === value.value }, item.label + index)); }) })) }))));
};
exports.TextInputMenu = TextInputMenu;
